/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.22.0
 */

import { EBreadCrumbType } from '@modules/breadCrumbs/breadCrumbsTypes';

export const setAutoReportIdBreadCrumbs = (isReportsConstructorAvailable: boolean): EBreadCrumbType[] => {
    const breadCrumb = isReportsConstructorAvailable ? EBreadCrumbType.reportsConstructor : EBreadCrumbType.autoReport;

    return [breadCrumb, EBreadCrumbType.autoReportId];
};
